<template>
  <span>
    <InternalLink
      v-if="link && link[0]?._type == 'internalLink'"
      v-bind="link[0]"
    >
      <template #default>
        <span>{{ text }} <slot /></span>
      </template>
    </InternalLink>
    <ExternalLink
      v-else-if="link && link[0]?._type == 'externalLink'"
      v-bind="link[0]"
    >
      <template #default>
        <span>{{ text }} <slot /></span>
      </template>
    </ExternalLink>
    <PDFLink
      v-else-if="link && link[0]?._type == 'pdfLink'"
      v-bind="link[0]"
    >
      <template #default>
        <span :class="$attrs.class">{{ text }} <slot /></span>
      </template>
    </PDFLink>

    <span v-else>{{ text }} <slot /></span>
  </span>
</template>

<script setup lang="ts">
import ExternalLink from '~/components/Atmos/ExternalLink/ExternalLink.vue';
import InternalLink from '~/components/Atmos/InternalLink/InternalLink.vue';
import PDFLink from '~/components/Atmos/PDFLink/PDFLink.vue';
import type { GeneralLink } from '~/sanity/types';
defineProps<GeneralLink>();
</script>

<style scoped></style>
